import styled from '@emotion/styled';
import {
  atom,
  useAtom,
} from 'jotai';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';
import {
  layoutMaxWidth,
  layoutPadding,
} from '../../layout-styles';
import type { GnbItem } from '../gnb-menu';
import { useGnbMenu } from '../gnb-menu';
import Lnb from './Lnb';
import NavItem from './NavItem';
import ImageButton from '@/components/comm/ImageButton';
import { breakpointMedium } from '@/constants/breakpoints';
import { testIds } from '@/constants/test-ids';
import { useBreakpoint } from '@/lib/breakpoint.service';
import icMainLogo from '@/public/images/ic-main-logo.svg';

const Container = styled.div`
width: 100%;
max-width: ${layoutMaxWidth};
font-size: 16px;
line-height: 23.17px;

@media (max-width: ${breakpointMedium}) {
  font-size: 13px;
  line-height: 18.82px;
}
`;

const LowerHeader = styled.div`
display: grid;
justify-content: space-between;
padding: ${layoutPadding};
grid-template-columns: repeat(2, max-content);
line-height: 23.17px;
overflow-x: auto;

@media (max-width: ${breakpointMedium}) {
  max-width: 100%;
  justify-content: start;
  column-gap: 16px;
  font-size: 13px;
  grid-template-columns: 96.4px max-content;
  line-height: 18.82px;
}

& > a {
  display: grid;
}
`;

const Nav = styled.nav`
display: flex;
height: 64px;

@media (max-width: ${breakpointMedium}) {
  height: 48px;
}
`;

export const lnbActiveAtom = atom<GnbItem | null>(null);

const Lower = () => {
  const [lnbActive, setLnbActive] = useAtom(lnbActiveAtom);
  const breakpoint = useBreakpoint();

  const { route } = useRouter();
  const gnbMenu = useGnbMenu();

  const isNarrow = useMemo(
    () => ['sm', 'md'].includes(breakpoint),
    [breakpoint],
  );

  useEffect(() => setLnbActive(null), [route, setLnbActive]);

  useEffect(() => {
    !isNarrow && lnbActive && setLnbActive(null);
  }, [isNarrow, lnbActive, setLnbActive]);

  return (
    <Container>
      <LowerHeader>
        <Link href="/">
          <ImageButton
            src={icMainLogo}
            alt="main logo"
            style={{ maxWidth: '100%' }}
          />
        </Link>
        <Nav data-testid={testIds.gnb.GnbNav}>
          {gnbMenu.map((menu, index) => (
            <NavItem
              key={menu.title}
              menu={menu}
              isLastItem={index === gnbMenu.length - 1}
            />
          ))}
        </Nav>
      </LowerHeader>
      {isNarrow && gnbMenu.map((menu) => (
        <Lnb
          key={menu.title}
          menu={menu}
        />
      ))}
    </Container>
  );
};

export default Lower;
